import { cn } from '@/utils/tailwind-util';

export const UserIcon = ({ width, height, viewBox, fill, styles }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={width || '24'}
    height={height || '24'}
    viewBox={viewBox || '0 0 24 24'}
    strokeWidth="1.5"
    stroke="currentColor"
    className={cn(styles, 'size-6')}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
    />
  </svg>
);
